var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export const isMobile = () => {
    if (typeof window.navigator === 'undefined' ||
        typeof window.navigator.userAgent !== 'string')
        return false;
    return /Mobi|Android|iPhone/i.test(window.navigator.userAgent);
};
// This function will return 'true' when the specified permission has been denied by the user.
// If the API doesn't exist, or the query function returns an error, 'false' will be returned.
export function isPermissionDenied(name) {
    return __awaiter(this, void 0, void 0, function* () {
        const permissionName = name; // workaround for https://github.com/microsoft/TypeScript/issues/33923
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        if (window.navigator.permissions) {
            try {
                const result = yield window.navigator.permissions.query({
                    name: permissionName
                });
                return result.state === 'denied';
            }
            catch (_a) {
                return false;
            }
        }
        else {
            return false;
        }
    });
}
//# sourceMappingURL=index.js.map